import type { UserRole } from '../types/auth'

export const APP_ROUTES = {
  DASHBOARD: '/dashboard',
  STUDENTS: '/etudiants',
  PROGRAMMES: '/programmes',
  PROFILE: '/profil',
  ADMINISTRATION: '/administration',
  ACTION_TIMER: '/action-timer',
  SCAN: '/scan',
  CALENDAR: '/calendar',
  EVENTS: '/events',
  PLANNING: '/planning',
  FORMATEURS: '/formateurs',
  LOGS: '/logs',
  ERRORS: '/erreurs',
  SYSTEM: '/systeme',
} as const

export type AppRoute = typeof APP_ROUTES[keyof typeof APP_ROUTES]

export const ROLE_PERMISSIONS: Record<UserRole, AppRoute[]> = {
  etudiant: [
    APP_ROUTES.DASHBOARD,
    APP_ROUTES.STUDENTS,
    APP_ROUTES.PROFILE,
    APP_ROUTES.ACTION_TIMER,
    APP_ROUTES.SCAN,
    APP_ROUTES.CALENDAR,
    APP_ROUTES.EVENTS,
    APP_ROUTES.PLANNING,
  ],
  parent: [
    APP_ROUTES.DASHBOARD,
    APP_ROUTES.PROFILE,
    APP_ROUTES.ACTION_TIMER,
    APP_ROUTES.SCAN,
  ],
  professeur: [
    APP_ROUTES.DASHBOARD,
    APP_ROUTES.STUDENTS,
    APP_ROUTES.PROGRAMMES,
    APP_ROUTES.ADMINISTRATION,
    APP_ROUTES.PROFILE,
    APP_ROUTES.ACTION_TIMER,
    APP_ROUTES.SCAN,
  ],
  admin: [
    APP_ROUTES.DASHBOARD,
    APP_ROUTES.FORMATEURS,
    APP_ROUTES.STUDENTS,
    APP_ROUTES.PROGRAMMES,
    APP_ROUTES.ADMINISTRATION,
    APP_ROUTES.LOGS,
    APP_ROUTES.ERRORS,
    APP_ROUTES.SYSTEM,
    APP_ROUTES.PROFILE,
  ],
}

export function hasAccessToRoute(userRole: UserRole | undefined, route: string): boolean {
  if (!userRole) return false
  const permissions = ROLE_PERMISSIONS[userRole]
  return permissions.some(allowedRoute => route.startsWith(allowedRoute))
}

export function getAccessibleRoutes(userRole: UserRole): AppRoute[] {
  return ROLE_PERMISSIONS[userRole] || []
}

export function getDefaultRoute(_userRole: UserRole): AppRoute {
  return APP_ROUTES.DASHBOARD
}
